module.exports = __webpack_public_path__ + "img/Sokratis.d9b60e77.png";